import { render, staticRenderFns } from "./RadioSpeech.vue?vue&type=template&id=92a58714&scoped=true&lang=pug"
import script from "./RadioSpeech.vue?vue&type=script&lang=js"
export * from "./RadioSpeech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a58714",
  null
  
)

export default component.exports